import Bind from 'bind.js';


export default class VideoGuides {
  constructor({parentElement, data}) {
    this.parentElement = parentElement;
    this.data = data;
    this.addContent();
  }

  addContent() {
    let template = `
      <div class="tutorials">
      </div>
    `

    this.parentElement.insertAdjacentHTML("afterbegin", template);

    this.editor = Bind(
      {
        tutorials: this.data.get('tutorials').toJS()
      },
      {
        tutorials: {
          dom: '.tutorials',
          transform: function(tutorial) {
            return `<div class="tutorial">
              <iframe class="span7"
                      width="100%" height="270px" src="${tutorial.url}" frameborder="0" allowfullscreen></iframe>
              <div class="info span5">
                <div class="name">${tutorial.name}</div>
                <div class="summary">${tutorial.summary}</div>
              </div>
            </div>`;
          }
        }
      }
    );
  }

  reRender(data) {
    this.data = data;
    this.editor.tutorials = data.get('tutorials').toJS();
  }
}



// WEBPACK FOOTER //
// ./src/renderers/VideoGuides.js